import React, { useCallback, useEffect, useState } from "react";

import Preloader from "./Preloader";

import IslandHeader from "./IslandHeader";

import Footer from "./Footer";

import SmoothScroll from "./SmoothScroll";

import ScrollToTop from "./ScrollToTop";

import FloatingContact from "./FloatingContact";

import SeoHead from "./SeoHead";

import MaintenanceScreen from "./MaintenanceScreen";

import CookieBanner from "./CookieBanner";
import GoogleAnalytics from "./GoogleAnalytics";
import { CookieConsentProvider } from "@/context/CookieConsentContext";
import { ROUTES, servicePath } from "@/lib/routes";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import PortfolioPage from "@/pages/PortfolioPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";


import { Routes, Route, Navigate, useParams } from "react-router-dom";



const defaultMaint = {

  enabled: false,

  headline_ro: "Revinem în curând",

  headline_en: "We'll be back soon",

  body_ro: "",

  body_en: "",

};



function LegacyServiceRedirect() {

  const { slug } = useParams();

  return <Navigate to={servicePath(slug)} replace />;

}



function PublicRoutesInner() {

  return (

    <CookieConsentProvider>

      <div className="min-w-0 overflow-x-clip">

        <SmoothScroll />

        <SeoHead />

        <ScrollToTop />

        <Preloader />

        <IslandHeader />

        <Routes>

          <Route path="/" element={<HomePage />} />

          <Route path={ROUTES.services} element={<ServicesPage />} />
          <Route path={`${ROUTES.services}/:slug`} element={<ServiceDetailPage />} />
          <Route path={ROUTES.articles} element={<ArticlesPage />} />
          <Route path={`${ROUTES.articles}/:slug`} element={<ArticleDetailPage />} />
          <Route path={ROUTES.portfolio} element={<PortfolioPage />} />
          <Route path={ROUTES.about} element={<AboutPage />} />

          <Route path={ROUTES.contact} element={<ContactPage />} />

          <Route path={ROUTES.privacy} element={<LegalPage docKey="privacy" />} />

          <Route path={ROUTES.terms} element={<LegalPage docKey="terms" />} />

          <Route path={ROUTES.cookies} element={<LegalPage docKey="cookies" />} />



          {/* Legacy English URLs — client-side fallback if .htaccess redirect missed */}

          <Route path="/services" element={<Navigate to={ROUTES.services} replace />} />

          <Route path="/services/:slug" element={<LegacyServiceRedirect />} />

          <Route path="/portfolio" element={<Navigate to={ROUTES.portfolio} replace />} />

          <Route path="/about" element={<Navigate to={ROUTES.about} replace />} />

        </Routes>

        <Footer />

        <FloatingContact />

        <CookieBanner />
        <GoogleAnalytics />
      </div>
    </CookieConsentProvider>

  );

}



export default function PublicSiteGate() {

  const [status, setStatus] = useState(null);



  const loadStatus = useCallback(async () => {

    try {

      const r = await fetch("/api/maintenance-status.php", { cache: "no-store", credentials: "include" });

      const j = await r.json();

      if (j.ok) {

        setStatus(j);

      } else {

        setStatus({ ...defaultMaint, enabled: false, bypassed: false, has_bypass_password: false });

      }

    } catch {

      setStatus({ ...defaultMaint, enabled: false, bypassed: false, has_bypass_password: false });

    }

  }, []);



  useEffect(() => {

    loadStatus();

  }, [loadStatus]);



  if (status === null) {

    return (

      <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-[#3e2723]" aria-busy="true">

        <div className="h-10 w-10 animate-pulse rounded-2xl bg-[#fbd9e5]/20" />

        <p className="text-xs font-medium tracking-wide text-[#fbd9e5]/55">Se încarcă…</p>

      </div>

    );

  }



  if (status.enabled && !status.bypassed) {

    return <MaintenanceScreen settings={status} onBypass={loadStatus} />;

  }



  return <PublicRoutesInner />;

}

